<template>
  <div
    class="w-full flex gap-3 justify-start items-center relative overflow-hidden  cursor-pointer select-none"
    :class="[
      isAnimating ? 'fill-active': '',
      noBorder ? 'ps-6 pe-4' : 'py-2 px-3 border border-gray-200 rounded-lg',
      bg ? `bg-${bg}-50`:  'bg-white']"
    @click="handleClick"
  >
    <Avatar
      v-if="fullName || img"
      :label="img ? undefined : fullName ? getTwoChars(fullName) : ''"
      :image="img"
      size="normal"
      shape="circle"
      class="bg-[#b798f5] rounded-2xl text-white relative z-10 flex-none" />
    <i v-else-if="icon" :class="[
      'rounded-full p-2.5 pi text-gray-500', icon,
      bg ? `bg-${bg}-100`: 'bg-gray-100'
      ]" style="font-size: 0.85rem;" />

    <div class="w-full flex justify-between items-center"
    :class="[noBorder ? `${lastItem ? '' : 'border-b'} py-4` : '']">
      <div class="flex flex-col gap-1 items-start justify-start relative z-10">
        <span class="font-medium">{{title}}</span>
        <span v-if="subtitle" class="text-xs pe-2 text-gray-500">{{subtitle}}</span>
      </div>

      <i class="pi pi-chevron-left rtl-icon text-gray-400" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { getTwoChars } from '@torim-app/utils';

defineProps({
  icon: { type: String, required: false },
  img: { type: String, required: false },
  title: { type: String, required: true },
  subtitle: { type: String, required: false },
  fullName: { type: String, required: false },
  noBorder: { type: Boolean, required: false, default: false },
  lastItem: { type: Boolean, required: false, default: false },
  bg: { type: String, required: false },
});

const emit = defineEmits(['click']);
const isAnimating = ref(false);

const handleClick = () => {
  if (isAnimating.value) return;

  isAnimating.value = true;
  setTimeout(() => {
    emit('click');
    isAnimating.value = false;
  }, 400);
};
</script>

<style scoped>
.fill-active::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  background-color: rgba(0, 0, 0, 0.06);

  transform: scaleX(0);
  transform-origin: right;

  z-index: 0;
  pointer-events: none;

  animation: fill-wipe-fade 0.7s ease-out forwards;
}

@keyframes fill-wipe-fade {
  0% {
    transform: scaleX(0);
    opacity: 1;
  }
  50% {
    transform: scaleX(1);
    opacity: 1;
  }
  100% {
    transform: scaleX(1);
    opacity: 0;
  }
}
</style>
